'use client';

export { default } from './Box';
export { default as boxClasses } from './boxClasses';
export * from './boxClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/system/esm/Box/index.js
// module id = 1575
// module chunks = 22